export const BetaFeatures = Object.freeze({
  ACQUISITION_23970_MOBILE_BREADCRUMBS_MENU: 'ACQUISITION_23970_MOBILE_BREADCRUMBS_MENU',
});
